import { render, staticRenderFns } from "./checkinfo_checkhole.vue?vue&type=template&id=006c5952&scoped=true&"
import script from "./checkinfo_checkhole.vue?vue&type=script&lang=js&"
export * from "./checkinfo_checkhole.vue?vue&type=script&lang=js&"
import style0 from "./checkinfo_checkhole.vue?vue&type=style&index=0&id=006c5952&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006c5952",
  null
  
)

export default component.exports